import { type ReconcileSession } from '@webapp/modules/accounts-payable/entities/ReconcileSession'
import { useEditReconcileSessionPresenter } from './useEditReconcileSessionPresenter'
import { SessionStatementControls } from '../../views/SessionStatementControls'

export interface IEditReconcileSessionPresenterProps {
  session: ReconcileSession
  /** Card currency label beside the balance input */
  currencyName: string
  /** "Last statement: {date}" caption source (account context) */
  lastStatementDate: Nullable<Date>
  /** FS recomputes overall variance from the updated balance (BHV-035/036) */
  onSessionChange: (session: ReconcileSession) => void
}

export const EditReconcileSessionPresenter = ({
  session,
  currencyName,
  lastStatementDate,
  onSessionChange,
}: IEditReconcileSessionPresenterProps) => {
  const {
    data: { statementDate, balanceValue, status, isDatePickerFocused },
    methods: {
      onDatePickerFocusChange,
      onStatementDateChange,
      onBalanceChange,
      onBalanceBlur,
      onBalanceKeyDown,
    },
  } = useEditReconcileSessionPresenter({ session, onSessionChange })

  return (
    <SessionStatementControls
      session={session}
      currencyName={currencyName}
      lastStatementDate={lastStatementDate}
      statementDateValue={statementDate}
      isDatePickerFocused={isDatePickerFocused}
      onDatePickerFocusChange={onDatePickerFocusChange}
      onStatementDateChange={onStatementDateChange}
      balanceValue={balanceValue}
      status={status}
      onBalanceChange={onBalanceChange}
      onBalanceBlur={onBalanceBlur}
      onBalanceKeyDown={onBalanceKeyDown}
    />
  )
}

EditReconcileSessionPresenter.displayName = 'EditReconcileSessionPresenter'
